import { LoadingSpinner } from '@/components/common/LoadingSpinner';
import type { EstimatorAccount } from '../types/commission';

interface AccountSummaryCardProps {
  account: EstimatorAccount | null | undefined;
  isLoading: boolean;
}

/**
 * Displays estimator account summary as plain body text.
 * Shows total earned, total draws, and balance without cards, colors, or icons.
 */
export function AccountSummaryCard({ account, isLoading }: AccountSummaryCardProps) {
  if (isLoading) {
    return (
      <div className="flex justify-center py-8">
        <LoadingSpinner label="Loading account..." />
      </div>
    );
  }

  if (!account) {
    return null;
  }

  const formatCurrency = (amount: number) =>
    new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(amount);

  return (
    <div className="flex flex-wrap items-center gap-x-6 gap-y-1 text-sm">
      <span>
        <span className="text-muted-foreground">Total Earned:</span>{' '}
        {formatCurrency(account.totalEarned)}
      </span>
      <span>
        <span className="text-muted-foreground">Total Draws:</span>{' '}
        {formatCurrency(account.totalDraws)}
      </span>
      <span>
        <span className="text-muted-foreground">Balance:</span>{' '}
        {formatCurrency(account.accountBalance)}
      </span>
    </div>
  );
}
